import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES = [
  { pattern: /^\/$/, label: 'Home' },
  { pattern: /^\/login\/?$/, label: 'Login' },
  { pattern: /^\/forgot-password\/?$/, label: 'Password Reset' },
  { pattern: /^\/employee-self-service\/?$/, label: 'Employee Self-Service' },
  { pattern: /^\/manager-self-service\/?$/, label: 'Manager Self-Service' },
  { pattern: /^\/internal-messaging\/?$/, label: 'Chat' },
  { pattern: /^\/employee-directory\/?$/, label: 'Employee Directory' },
  { pattern: /^\/employee-directory\/[^/]+\/?$/, label: 'Employee Review' },
  { pattern: /^\/time-off-management\/?$/, label: 'Time Off Management' },
  { pattern: /^\/employee-scheduling\/?$/, label: 'Employee Scheduling' },
  { pattern: /^\/incident-reports\/?$/, label: 'Incident Reports' },
  { pattern: /^\/hiring\/?$/, label: 'Hiring' },
  { pattern: /^\/support\/?$/, label: 'Support' },
  { pattern: /^\/settings\/?$/, label: 'Settings' },
  { pattern: /^\/onboarding\/?$/, label: 'Onboarding' },
  { pattern: /^\/.*$/, label: 'Not Found' },
];

const BASE_TITLE = 'Ougama';

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location?.pathname ?? '/';
    const matched = TITLES.find(({ pattern }) => pattern.test(pathname));
    const nextTitle = matched ? `${BASE_TITLE} | ${matched.label}` : BASE_TITLE;

    if (document.title !== nextTitle) {
      document.title = nextTitle;
    }
  }, [location?.pathname]);

  return null;
};

export default PageTitle;
